import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  useTheme,
  alpha,
} from "@mui/material";
import { formatCurrencyV2 } from "../utils/helpers";

const WalletBalanceCard = ({
  icon: Icon,
  title,
  balance,
  color = "primary",
}) => {
  const theme = useTheme();
  // Safely get the main color from the theme palette
  const mainColor = theme.palette[color]?.main || theme.palette.primary.main;

  return (
    <Card
      sx={{
        borderBottom: `4px solid ${mainColor}`,
        boxShadow: `0 12px 24px -4px ${alpha(mainColor, 0.2)}`,
      }}
    >
      <CardContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography color="text.secondary" variant="subtitle2" gutterBottom>
              {title}
            </Typography>

            <Typography variant="h5" fontWeight="700">
              {formatCurrencyV2(balance)}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 52,
              height: 52,
              borderRadius: "50%",
              color: "#fff",
              backgroundColor: mainColor,
            }}
          >
            <Icon sx={{ fontSize: 32 }} />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default WalletBalanceCard;
